// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  connect: ['navigate'],
  connectSuccess: [],

  login: ['params', 'navigate'],
  loginSuccess: ['token'],
  loginFailure: ['error'],

  signup: ['params', 'navigate'],
  signupSuccess: ['token'],
  signupFailure: ['error'],

  signOut: ['navigate'],
  signOutSuccess: [],

  checkAuthentication: [],
  checkAuthenticationSuccess: [],
});

export const INITIAL_STATE = Immutable({
  error: null,
  user: undefined,
  isProcessing: false,
  isLoggedIn: false,
  token: null,
  isAppReady: false,
});

const connect = (state = INITIAL_STATE) => state;

const connectSuccess = (state = INITIAL_STATE, { payload }) =>
  state
    .set('isLoggedIn', payload.isLoggedIn)
    .set('user', payload.user)
    .set('token', payload.token)
    .set('isAppReady', true);

const requestAuth = (state = INITIAL_STATE) => {
  return state.set('isProcessing', true).set('error', null);
};

const requestAuthSuccess = (state = INITIAL_STATE, { payload }) => {
  const nextState = state
    .set('isLoggedIn', payload.isLoggedIn)
    .set('token', payload.token)
    .set('error', null)
    .set('isProcessing', false);
  return nextState;
};

const requestAuthFailure = (state = INITIAL_STATE, { payload }) => {
  return state.set('error', payload.error).set('isProcessing', false);
};

const requestSuccess = (state = INITIAL_STATE) => {
  return state.set('error', null).set('isProcessing', false);
};

const signOut = (state = INITIAL_STATE) => state;

const signOutSuccess = (state) => {
  const nextState = state
    .set('isLoggedIn', false)
    .set('user', undefined)
    .set('token', null)
    .set('error', null)
    .set('isProcessing', false)
    .set('isAppReady', true);
  return nextState;
};

export const AuthTypes = Types;

export const AuthReducer = createReducer(INITIAL_STATE, {
  [Types.CONNECT]: connect,
  [Types.CONNECT_SUCCESS]: connectSuccess,
  [Types.LOGIN]: requestAuth,
  [Types.LOGIN_SUCCESS]: requestAuthSuccess,
  [Types.LOGIN_FAILURE]: requestAuthFailure,
  [Types.SIGNUP]: requestAuth,
  [Types.SIGNUP_SUCCESS]: requestSuccess,
  [Types.SIGNUP_FAILURE]: requestAuthFailure,
  [Types.SIGN_OUT]: signOut,
  [Types.SIGN_OUT_SUCCESS]: signOutSuccess,
});

export const AuthActions = Creators;
